import {ReservationPaymentSummary, SUMMARY_PAYMENTS_STATUSES} from '@guestapp/sdk';

export const checkIsPaymentNotComplete = (paymentSummary?: ReservationPaymentSummary) => {
  return paymentSummary?.status === SUMMARY_PAYMENTS_STATUSES.configurationPending;
};
